import { Component } from '@angular/core';
import { ConfigService } from './shared/services/config.service';
import { ConfigService as AnalyticsConfigService } from '@wdpr/angular-analytics';
import { environment } from '../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { TranslatePipe } from './shared/pipes/translate.pipe';

import '@polymer/iron-flex-layout/iron-flex-layout.js';
import '@com/theme-pep';
import '@com/inspire-fonts';
import '@com/dlr-avl-cal-ui-components';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [TranslatePipe]
})
export class AppComponent {
  /**
   * Application configuration
   * @var {any}
   */
  private _config: any;

  /**
   * Component constructor
   *
   * @param _configService
   * @param _analyticsConfig
   * @param _title
   * @param _meta
   * @param _translatePipe
   */
  constructor(
      private _configService: ConfigService,
      private _analyticsConfig: AnalyticsConfigService,
      private _title: Title,
      private _meta: Meta,
      private _translatePipe: TranslatePipe
  ) {
    this._config = this._configService.getConfig();
    this._analyticsConfig.serverPath = `${environment.analyticsServerPath}/${this._config.environment}`;
    this._title.setTitle(this._translatePipe.transform('seo.title'));
    this._meta.addTag({ name: 'description', content: this._translatePipe.transform('meta.description')});
    this._meta.addTag({ name: 'keywords', content: this._translatePipe.transform('meta.keywords')});
  }
}
